import { useCallback, useEffect, useState } from "react";
import {
  crearNota,
  editarNota,
  eliminarNota,
  getNotas,
} from "./notasCuentaCorrienteService";

export const useNotasCuentaCorriente = (idCliente, envasado, open) => {
  const [notas, setNotas] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!open || !idCliente) return;

    try {
      setLoading(true);

      const data = await getNotas(idCliente, envasado);

      setNotas(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [idCliente, envasado, open]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const crear = async ({ nota, user }) => {
    await crearNota({
      idCliente,
      nota,
      user,
      envasado,
    });

    await refresh();
  };

  const editar = async (id, nota) => {
    await editarNota(id, nota);

    await refresh();
  };

  const eliminar = async (id) => {
    await eliminarNota(id);

    await refresh();
  };

  return {
    notas,
    loading,
    crear,
    editar,
    eliminar,
    refresh,
  };
};
